import React from "react";
import { Line } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler } from "chart.js";
import zoomPlugin from 'chartjs-plugin-zoom';

// Registrace Filler pluginu spolu s ostatními
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler, zoomPlugin);

const ChartComponent = ({ data }) => {
  const chartData = {
    labels: data.labels,
    datasets: [
      {
        label: "CRW Price (ETH)",
        data: data.values,
        borderColor: "#d4af37",
        backgroundColor: "rgba(212, 175, 55, 0.2)",
        tension: 0.3,
        fill: true, // Tato vlastnost vyžaduje Filler plugin
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { position: "top", labels: { color: "#d4af37" } },
      title: { display: true, text: "CRW Price History (ETH)", color: "#d4af37" },
      tooltip: {
        callbacks: {
          label: (context) => `${context.dataset.label}: ${context.parsed.y.toFixed(9)} ETH`,
        },
      },
      zoom: {
        zoom: {
          wheel: { enabled: true },
          pinch: { enabled: true },
          mode: "x",
        },
        pan: {
          enabled: true,
          mode: "x",
        },
      },
    },
    scales: {
      x: {
        ticks: { color: "#b0b0b0" },
        title: { display: true, text: "Time", color: "#d4af37" },
      },
      y: {
        min: 0,
        ticks: {
          color: "#b0b0b0",
          callback: (value) => `${value.toFixed(6)} ETH`,
        },
        title: { display: true, text: "Price (ETH)", color: "#d4af37" },
      },
    },
  };

  return <Line data={chartData} options={options} />;
};

export default ChartComponent;